import { GroupBase, StylesConfig } from 'react-select';

import { IconSize } from 'app/design-system/types/Icon';

export function setCustomStyles<
  T,
  IsMulti extends boolean,
  Group extends GroupBase<T>
>(): StylesConfig<T, IsMulti, Group> {
  return {
    container: (provided, state) => ({
      ...provided,
      pointerEvents: state.isDisabled ? 'auto' : provided.pointerEvents,
    }),
  };
}

export const enum DropdownSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  DEFAULT = 'default',
}

const ICON_LARGE = 20;

export const dropdownIconsSizes = {
  [DropdownSize.DEFAULT]: IconSize.MEDIUM,
  [DropdownSize.SMALL]: IconSize.MEDIUM,
  [DropdownSize.MEDIUM]: ICON_LARGE,
  [DropdownSize.LARGE]: IconSize.DEFAULT,
};
